export interface ObjectTypeOption {
  title: string;
  value: number;
}

export interface ModulesOption {
  label: string;
  value: number;
  selected: boolean;
}

export interface TooltipTexts {
  text: string;
  value: number;
}

export enum ExclusionItemFormEvents {
  CREATE_NEW_EXCLUSION_ITEM = 'createNewExclusionItem',
  CHANGE_OBJECT_TYPE = 'changeObjectType',
  IMPORT_EXCLUSIONS = 'importExclusions',
}
